export const serializeFormdata = (object: any) => {
  let output = ''
  let index = 0
  const dilimiter = () => (index++ ? '&' : '?')

  for (const prop in object) {
    if (object.hasOwnProperty(prop)) {
      switch (Object.prototype.toString.call(object[prop])) {
        case '[object Array]':
          for (const prop2 in object[prop]) {
            if (object[prop].hasOwnProperty(prop2)) {
              output += `${dilimiter()}${prop}[]=${encodeURIComponent(object[prop][prop2])}`
            }
          }
          break
        case '[object Object]':
          for (const prop3 in object[prop]) {
            if (object[prop].hasOwnProperty(prop3)) {
              output += `${dilimiter()}${prop}[${prop3}]=${encodeURIComponent(object[prop][prop3])}`
            }
          }
          break
        default:
          output += `${dilimiter()}${prop}=${encodeURIComponent(object[prop])}`
      }
    }
  }

  return output
}